import { render, staticRenderFns } from "./PortsmouthCity.vue?vue&type=template&id=5655c9e4&scoped=true&"
import script from "./PortsmouthCity.vue?vue&type=script&lang=js&"
export * from "./PortsmouthCity.vue?vue&type=script&lang=js&"
import style0 from "./PortsmouthCity.vue?vue&type=style&index=0&id=5655c9e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5655c9e4",
  null
  
)

export default component.exports